module.exports = __webpack_public_path__ + "img/voltaje_a.36b0a1b6.svg";